// Vendor theme -> CSS custom property plumbing. The Tailwind palette reads
// rgb(var(--accent-rgb, 255 0 65) / <alpha>) so a null return (no/invalid
// theme) simply leaves the Mikla defaults in place.
export function hexToRgbChannels(hex?: string | null): string | null {
  if (!hex || !/^#[0-9a-f]{6}$/i.test(hex)) return null
  const n = parseInt(hex.slice(1), 16)
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`
}

// Hover shade derived client-side (one color to pick in the portal, not two).
// 0.88 matches the ratio of the stock hover (#e50039) to the stock accent.
export function darkenChannels(channels: string, factor = 0.88): string {
  return channels.split(' ').map((c) => String(Math.round(Number(c) * factor))).join(' ')
}
